import { render, staticRenderFns } from "./DesktopTopMenu.vue?vue&type=template&id=59605618&"
import script from "./DesktopTopMenu.vue?vue&type=script&lang=js&"
export * from "./DesktopTopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports